import React from 'react'
import PropTypes from 'prop-types'

import * as styles from './TextWithIcon.styles'

export default class TextWithIcon extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node,
    empty: PropTypes.bool,
    icon: PropTypes.string,
    multiline: PropTypes.bool,
    row: PropTypes.bool,
    style: PropTypes.object,
    iconStyle: PropTypes.object,
  }

  render() {
    const { children, empty, icon, multiline, row, style, iconStyle = {}, ...rest } = this.props

    const baseWrapperStyle = row ? styles.wrapperRow : styles.wrapper
    const wrapperStyle = style ? { ...baseWrapperStyle, ...style } : baseWrapperStyle
    const textStyle = styles[`text${multiline ? '' : 'Ellipsis'}${empty ? 'Empty' : ''}`]
    const spriteIconStyle = { ...(row ? styles.iconRow : styles.icon), ...iconStyle }

    return (
      <view style={wrapperStyle} {...rest}>
        {Boolean(icon) && <sprite image={icon} style={spriteIconStyle} />}
        {Boolean(children) && <richtext style={textStyle} text={children} />}
      </view>
    )
  }
}
